import Button from "../../../../shared/components/Button";
import { getLeagueTexts } from "../../shared/leagueTexts";
import { getLeagueRosterTexts } from "../../shared/leagueRosterTexts";
import LeagueLayout from "../../shared/components/LeagueLayout";
import LeagueOrganizerAccess from "../components/LeagueOrganizerAccess";
import LeagueParticipantsEditor from "../components/LeagueParticipantsEditor";

export default function LeagueParticipantsPage({ leagueId }: { leagueId: string }) {
  const t = getLeagueRosterTexts();
  return <LeagueLayout title={t.title}>
    <div className="league-actions"><Button href={`#/organizador/ligas/${leagueId}`} variant="ghost">{getLeagueTexts().edit}</Button></div>
    <LeagueOrganizerAccess><LeagueParticipantsEditor key={leagueId} leagueId={leagueId} /></LeagueOrganizerAccess>
  </LeagueLayout>;
}
